<template>
  <div>
    <div v-if="loading" class="loading-indicator">
      <p>Carregando...</p>
    </div>
    <div v-else>
      <form @submit.prevent="submitForm">
        <!-- Tipo da Revisão -->
        <b-form-group
          label="Tipo da Revisão"
          label-for="revisionType"
          class="mb-3"
        >
          <base-imput-logic
            id="revisionType"
            class="ml-0"
            :options="revisionTypeOptions"
            :value.sync="form.revisionType"
            required
          ></base-imput-logic>
        </b-form-group>

        <!-- Nome do Motorista -->
        <b-form-group
          label="Nome do Motorista"
          label-for="driverName"
          class="mb-3"
        >
          <multiselect
            id="driverName"
            v-model="selectedDriverOption"
            :options="driversOptions"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :multiple="false"
            placeholder="Selecione o motorista"
            label="text"
            track-by="text"
            class="multiselect-custom"
            required
            @input="handleDriverSelect"
          />
        </b-form-group>

        <!-- Placa -->
        <b-form-group label="Placa" label-for="plate" class="mb-3">
          <multiselect
            id="plate"
            v-model="selectedPlateOption"
            :options="platesOptions"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :multiple="false"
            placeholder="Selecione a placa"
            label="text"
            track-by="value"
            class="multiselect-custom"
            required
            @input="handlePlateSelect"
          />
        </b-form-group>

        <!-- Data da Revisão -->
        <b-form-group
          label="Data da Revisão"
          label-for="reviewDate"
          class="mb-3"
        >
          <b-form-input
            type="date"
            id="reviewDate"
            v-model="form.reviewDate"
            required
          />
        </b-form-group>

        <!-- Km -->
        <b-form-group label="Km" label-for="km" class="mb-3">
          <b-form-input type="number" id="km" v-model="form.km" required />
        </b-form-group>

        <!-- Local da Revisão -->
        <b-form-group
          label="Local da Revisão"
          label-for="revisionPlace"
          class="mb-3"
        >
          <base-imput-logic
            id="revisionPlace"
            class="ml-0"
            :options="placeOptions"
            :value.sync="form.revisionPlace"
            required
          ></base-imput-logic>
        </b-form-group>

        <!-- Descrição do Serviço ou Revisão -->
        <div v-if="form.revisionType !== 0">
          <!-- Descrição -->
          <b-form-group
            label="Descrição do Serviço"
            label-for="description"
            class="mb-3"
          >
            <b-form-textarea
              id="description"
              v-model="form.description"
              rows="3"
              required
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div v-else>
          <!-- Revisão Dropdown -->
          <b-form-group label="Revisão" label-for="revision" class="mb-3">
            <multiselect
              id="revision"
              v-model="selectedRevisionOption"
              :options="revisionOptions"
              :searchable="true"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              :multiple="false"
              placeholder="Selecione a revisão"
              label="text"
              track-by="value"
              class="multiselect-custom"
              required
              @input="handleRevisionSelect"
            />
          </b-form-group>
        </div>

        <!-- Botões de Ação -->
        <div class="d-flex justify-content-end mt-3">
          <b-button size="sm" type="submit" variant="green">
            {{ isEditMode ? "Atualizar" : "Registrar" }}
          </b-button>
          <b-button
            size="sm"
            variant="secondary"
            @click="$emit('close')"
            class="ml-2"
          >
            Cancelar
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    BaseImputLogic: () => import("@/components_rms/base/BaseImputLogic.vue")
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        ...this.model,
        vehicleId: this.model.vehicleId || null,
        driverName: this.model.driverName || "",
        revisionType: this.model.revisionType || null,
        revisionPlace: this.model.revisionPlace || "",
        reviewDate: this.model.reviewDate || "",
        km: this.model.km || "",
        description: this.model.description || "",
        VehicleRevisionId: this.model.VehicleRevisionId || null
      },
      driversOptions: [],
      platesOptions: [],
      selectedPlateOption: null,
      selectedDriverOption: null,
      selectedRevisionOption: null,
      placeOptions: [
        { text: "Interna", value: 0 },
        { text: "Externa", value: 1 }
      ],
      revisionTypeOptions: [
        { text: "Preventiva", value: 0 },
        { text: "Corretiva", value: 1 },
        { text: "Sinistro", value: 2 }
      ],
      revisionOptions: [],
      loading: true
    };
  },
  created: async function() {
    try {
      await this.getAllDrivers();
      if (this.form.revisionType === 0) {
        await this.getAllVehiclePlateWithRevision();
      } else {
        await this.getAllVehiclePlate();
      }
      this.initializeSelectedDriver();
      this.initializeSelectedPlate();
      if (this.form.revisionType === 0 && this.form.vehicleId) {
        await this.getDropdownRevisionByPlate(this.form.vehicleId);
        this.initializeSelectedRevision();
      }
    } catch (error) {
      console.error("Erro ao inicializar o componente:", error);
    } finally {
      this.loading = false;
    }
  },
  watch: {
    model(newModel) {
      this.form = {
        ...newModel,
        vehicleId: newModel.vehicleId || null,
        driverName: newModel.driverName || "",
        revisionType: newModel.revisionType || null,
        revisionPlace: newModel.revisionPlace || "",
        reviewDate: newModel.reviewDate || "",
        km: newModel.km || "",
        description: newModel.description || "",
        VehicleRevisionId: newModel.VehicleRevisionId || null
      };
      this.initializeSelectedPlate();
      this.initializeSelectedDriver();
      if (this.form.revisionType === 0 && this.form.vehicleId) {
        this.getDropdownRevisionByPlate(this.form.vehicleId);
      }
    },
    "form.revisionType"(newVal) {
      if (newVal === 0) {
        this.getAllVehiclePlateWithRevision();
        this.revisionOptions = [];
        this.selectedRevisionOption = null;
        this.form.VehicleRevisionId = null;
        this.form.description = "";
      } else {
        this.getAllVehiclePlate();
        this.revisionOptions = [];
        this.selectedRevisionOption = null;
        this.form.VehicleRevisionId = null;
        this.form.description = "";
      }
    }
  },
  methods: {
    async submitForm() {
      try {
        this.form.revisionPlace = Number(this.form.revisionPlace);
        this.form.revisionType = Number(this.form.revisionType);
        this.form.km = parseInt(this.form.km, 10);
        const payload = {
          ...this.form
        };
        if (this.isEditMode) {
          await this.$apiVehicle.post(
            `/EditRevisionEntry/${payload.id}`,
            payload
          );
        } else {
          await this.$apiVehicle.post("/CreateRevisionEntry/", payload);
        }
        this.$emit("success");
      } catch (error) {
        console.error(
          this.isEditMode
            ? "Erro ao atualizar entrada de manutenção:"
            : "Erro ao registrar entrada de manutenção:",
          error
        );
      }
    },
    async getAllDrivers() {
      try {
        const response = await this.$apiScheduler.get(
          "/v1/user/company/dropdownOptions/"
        );
        this.driversOptions = response.data.map(item => ({
          text: item.displayName,
          value: item.displayName
        }));
      } catch (error) {
        this.verifyExceptionType(error);
        throw error;
      }
    },
    async getAllVehiclePlate() {
      try {
        const response = await this.$apiVehicle.get(
          "/vehicleRegistration/GetAllDropdown/"
        );
        this.platesOptions = response.data.map(item => ({
          text: item.text,
          value: Number(item.value)
        }));
        this.initializeSelectedPlate();
      } catch (error) {
        this.verifyExceptionType(error);
      }
    },
    async getAllVehiclePlateWithRevision() {
      try {
        const response = await this.$apiVehicle.get("/GetPlatesWithRevision/");
        if (Array.isArray(response.data.result)) {
          this.platesOptions = response.data.result.map(item => ({
            text: item.text,
            value: Number(item.value)
          }));
          this.initializeSelectedPlate();
        } else {
          console.error(
            "Esperava um array, mas recebeu:",
            response.data.result
          );
          this.platesOptions = [];
        }
      } catch (error) {
        this.verifyExceptionType(error);
        throw error;
      }
    },
    async getDropdownRevisionByPlate(vehicleId) {
      try {
        const response = await this.$apiVehicle.get(
          `/vehicleModel/listDropdown/revisions/${vehicleId}`
        );
        if (Array.isArray(response.data)) {
          this.revisionOptions = response.data.map(item => ({
            text: item.text,
            value: Number(item.value)
          }));
          this.initializeSelectedRevision();
        } else {
          console.error("Esperava um array, mas recebeu:", response.data);
          this.revisionOptions = [];
        }
      } catch (error) {
        this.verifyExceptionType(error);
        throw error;
      }
    },
    handlePlateSelect(selectedOption) {
      if (selectedOption) {
        this.form.plate = selectedOption.text;
        this.form.vehicleId = Number(selectedOption.value);
        if (this.form.revisionType === 0) {
          this.getDropdownRevisionByPlate(this.form.vehicleId);
        }
      } else {
        this.form.plate = "";
        this.form.vehicleId = null;
        this.revisionOptions = [];
        this.selectedRevisionOption = null;
        this.form.VehicleRevisionId = null;
        this.form.description = "";
      }
    },
    handleDriverSelect(selectedOption) {
      if (selectedOption) {
        this.form.driverName = selectedOption.text;
      } else {
        this.form.driverName = "";
      }
    },
    handleRevisionSelect(selectedOption) {
      if (selectedOption) {
        this.form.description = selectedOption.text;
        this.form.VehicleRevisionId = Number(selectedOption.value);
      } else {
        this.form.description = "";
        this.form.VehicleRevisionId = null;
      }
    },
    initializeSelectedPlate() {
      if (this.form.plate && this.form.vehicleId !== null) {
        this.selectedPlateOption = this.platesOptions.find(
          option =>
            option.text === this.form.plate &&
            option.value === this.form.vehicleId
        );
        if (this.form.revisionType === 0 && this.form.vehicleId) {
          this.getDropdownRevisionByPlate(this.form.vehicleId);
        }
      } else {
        this.selectedPlateOption = null;
      }
    },
    initializeSelectedDriver() {
      if (this.form.driverName) {
        this.selectedDriverOption =
          this.driversOptions.find(
            option => option.text === this.form.driverName
          ) || null;
      } else {
        this.selectedDriverOption = null;
      }
    },
    initializeSelectedRevision() {
      if (this.form.VehicleRevisionId) {
        this.selectedRevisionOption =
          this.revisionOptions.find(
            option => option.value === this.form.VehicleRevisionId
          ) || null;
      } else {
        this.selectedRevisionOption = null;
      }
    },
    verifyExceptionType(error) {
      console.error("Erro na requisição:", error);
    }
  }
};
</script>

<style scoped>
.multiselect-custom {
  width: 100%;
}
.ml-2 {
  margin-left: 0.5rem;
}
.loading-indicator {
  text-align: center;
  padding: 20px;
  font-size: 1.2em;
  color: #555;
}
</style>
